import { attrs, html, type Html } from "./html.ts";

/**
 * Brand marks. The SVGs live in `assets/logos/` (vendored from the design project). The app serves them from
 * `logoBase`; change it with `setLogoBase` if they are hosted elsewhere. No GitHub, GitLab or Cloudflare logos.
 */
let base = "/assets/logos/";

export function setLogoBase(next: string): void {
  base = next.endsWith("/") ? next : `${next}/`;
}

type Mark = "lockup" | "mark";
const FILES = {
  lockup: { dark: "botallion-lockup-reverse.svg", light: "botallion-lockup-colour.svg" },
  mark: { dark: "botallion-mark-small-reverse.svg", light: "botallion-mark-small-ink.svg" },
} as const;

export const logo = {
  /** Wordmark with the emblem, for dark grounds. */
  lockup: (): string => `${base}${FILES.lockup.dark}`,
  /** The emblem on its own, colour. Reads on both grounds. */
  emblem: (): string => `${base}botallion-emblem-colour.svg`,
  /** The three-head mark for the nav and phone bars, for dark grounds. */
  mark: (): string => `${base}${FILES.mark.dark}`,
} as const;

/**
 * A theme-aware logo: both files are rendered and CSS shows the one for the current `data-theme`
 * (`.ap-logo--dark`, `.ap-logo--light` in app.css), so a screen follows the theme toggle without re-rendering.
 */
export function brandImg(kind: Mark, options: { alt?: string; style?: string } = {}): Html {
  const common = { alt: options.alt ?? "", style: options.style };
  return html`<img${attrs({ ...common, class: "ap-logo ap-logo--dark", src: `${base}${FILES[kind].dark}` })}><img${attrs({ ...common, class: "ap-logo ap-logo--light", src: `${base}${FILES[kind].light}` })}>`;
}
